"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.redirectLink = void 0;

var _locationOrigin = _interopRequireDefault(require("./locationOrigin"));

var _apiEnvironments = _interopRequireDefault(require("../constants/apiEnvironments"));

var _propTypeUtils = _interopRequireDefault(require("./propTypeUtils"));

var links = {
  shortlink: function shortlink() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return _locationOrigin.default + "/l/" + path;
  },
  productSetup: function productSetup(portalId) {
    var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!portalId) {
      return _locationOrigin.default + "/configuration/";
    }

    return _locationOrigin.default + "/configuration/" + portalId + "/" + product;
  },
  crmStartPage: function crmStartPage(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/start";
  },
  // ---------------------------------------------------------------------------
  // utilities
  login: function login(next) {
    var query = '';

    if (next) {
      query = "?loginRedirectUrl=" + encodeURIComponent(next);
    }

    return "https://" + _apiEnvironments.default.HUBSPOT_LOGIN + query;
  },
  loginWithRedirect: function loginWithRedirect(redirect) {
    var portalId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var path = encodeURIComponent(redirect);
    var redirectTo = "?loginRedirectUrl=" + path;
    var enforcePortal = '';

    if (portalId) {
      enforcePortal = "&loginPortalId=" + portalId;
    }

    return "" + links.login() + redirectTo + enforcePortal;
  },
  portalUpgrades: function portalUpgrades(portalId) {
    return _locationOrigin.default + "/upgrades/" + portalId;
  },
  // ---------------------------------------------------------------------------
  // features
  homeService: function homeService(portalId) {
    return _locationOrigin.default + "/home?portalId=" + portalId;
  },
  salesDashboard: function salesDashboard(portalId) {
    return _locationOrigin.default + "/reports-dashboard/" + portalId + "/sales";
  },
  // generic default
  marketingFree: function marketingFree(portalId) {
    return _locationOrigin.default + "/marketing/" + portalId + "/";
  },
  marketingFreeContacts: function marketingFreeContacts(portalId) {
    return _locationOrigin.default + "/marketing/" + portalId + "/contacts";
  },
  marketingFreeLeadFlows: function marketingFreeLeadFlows(portalId) {
    return _locationOrigin.default + "/lead-flows/" + portalId + "/";
  },
  marketingFreeForms: function marketingFreeForms(portalId) {
    return _locationOrigin.default + "/forms/" + portalId + "/";
  },
  developers: function developers(portalId) {
    return _locationOrigin.default + "/developers/" + portalId + "/";
  },
  // generic default
  crm: function crm(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId;
  },
  crmContacts: function crmContacts(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/contacts";
  },
  crmCompanies: function crmCompanies(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/companies";
  },
  crmDeals: function crmDeals(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/deals";
  },
  crmTasks: function crmTasks(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/tasks";
  },
  salesNotifications: function salesNotifications(portalId) {
    return _locationOrigin.default + "/sales-stream/" + portalId + "/all";
  },
  salesTemplates: function salesTemplates(portalId) {
    return _locationOrigin.default + "/templates/" + portalId + "/";
  },
  salesSequences: function salesSequences(portalId) {
    return _locationOrigin.default + "/sequences/" + portalId;
  },
  salesDocuments: function salesDocuments(portalId) {
    return _locationOrigin.default + "/presentations/" + portalId;
  },
  salesProspects: function salesProspects(portalId) {
    return _locationOrigin.default + "/contacts/" + portalId + "/visits";
  },
  salesMeetings: function salesMeetings(portalId) {
    return _locationOrigin.default + "/meetings/" + portalId;
  },
  salesPro: function salesPro(portalId) {
    return _locationOrigin.default + "/browse/" + portalId + "/compare/sales";
  },
  academy: function academy(portalId) {
    return _locationOrigin.default + "/learning-center/" + portalId;
  },
  oauth: function oauth(portalId) {
    return _locationOrigin.default + "/oauth/" + portalId + "/authorize";
  },
  oauthBeta: function oauthBeta(portalId) {
    return _locationOrigin.default + "/oauth-beta/" + portalId + "/authorize";
  },
  codeFunnelAnatomy: function codeFunnelAnatomy() {
    return 'https://offers.hubspot.com/thank-you/anatomy-of-a-five-star-email-b';
  },
  codeFunnelSeo: function codeFunnelSeo() {
    return 'https://offers.hubspot.com/thank-you/seo-myths-b';
  },
  codeFunnelInfographics: function codeFunnelInfographics() {
    return 'https://offers.hubspot.com/thank-you/generate-leads-with-infographics-b';
  },
  codeFunnelTemplates: function codeFunnelTemplates() {
    return 'https://offers.hubspot.com/thank-you/call-to-action-templates-b';
  }
};

function redirectLinkChecker(props, propName, componentName) {
  if (!Object.values(links).includes(props[propName])) {
    return new Error(propName + " specified in " + componentName + " is not valid. Use links defined in utils/links.js");
  }

  return null;
}

var redirectLink = (0, _propTypeUtils.default)(redirectLinkChecker);
exports.redirectLink = redirectLink;
var _default = links;
exports.default = _default;